class FixedBanner {

    constructor(parent) {
        this.parent = parent;

        // parent.addClass('fixed-banner');


        // START widget virtual 
        let widget = $(parent);
        this.widget = parent;

        let widgetOffsetTop = this.widget.offset() ? this.widget.offset().top : 0;
        this.widgetOffsetTop = widgetOffsetTop;

        let widgetScrollLimit = widgetOffsetTop + widget.outerHeight();
        this.widgetScrollLimit = widgetScrollLimit;

        let offset = 110;
        this.offset = offset;

        jQuery(document).on('scroll', (e) => this.onScroll());
        this.scrollLimit()

        this.keepGranparentHeight();

        setTimeout(() => this.onScroll(), 50);
    }

    keepGranparentHeight() {
        let grandParent = this.parent.parent();
        grandParent.css('height', grandParent.height())
    }

    scrollLimit() {
        this.widgetScrollLimit = this.widgetOffsetTop + this.widget.outerHeight();
    }


    onScroll() {
        if (document.documentElement.scrollTop + this.offset > this.widgetScrollLimit) {
            if (!this.widget.hasClass("fixed-banner")) {
                this.widget.addClass("fixed-banner")
            }
        } else {
            if (this.widget.hasClass("fixed-banner")) {
                this.widget.removeClass("fixed-banner");
            }
        }
    }

}


var fbs = jQuery('[data-module="FixedBanner"]');
for(var i=0; i<fbs.length; i++) {
    var fb = fbs.eq(i);
    new FixedBanner(fb);
}